@if (asset().type === 'image') {
  <img class="ambience" [style.background]="'url(' + (blurHashValue() | blurHash) + ')'" draggable="false" alt="" />
}
